<script setup lang="ts">
const preferencesStore = usePreferencesStore()
const userStore = useUserStore()
const content = preferencesStore.site?.articleSignUp?.content
const show = ref(false)

const disappearForThisSession = () => {
  show.value = false
  sessionStorage.setItem('showBrillianceSignUpCallout', 'n')
}

watchEffect(() => {
  if (userStore.isLoggedIn) {
    show.value = false
  }
})

onMounted(() => {
  if (userStore.isLoggedIn) {
    show.value = false
    return
  }

  const showBrillianceSignUpCallout = sessionStorage.getItem('showBrillianceSignUpCallout')
  if (showBrillianceSignUpCallout) {
    show.value = showBrillianceSignUpCallout === 'y'
  } else {
    show.value = true
    sessionStorage.setItem('showBrillianceSignUpCallout', 'y')
  }
})
</script>

<template>
  <section v-if="show" class="sticky-sign-up-panel">
    <Accordion name="articleSignUp" variant="secondary" :ga-options="{ group: 'content' }">
      <template #title>
        <h3 class="sticky-sign-up-panel__title">{{ $t('sign_up_callout.title') }}</h3>
      </template>
      <RichText :document="content" />
      <div class="sticky-sign-up-panel__buttons">
        <Anchor url="/my-account/register" variant="primary" class="sticky-sign-up-panel__buttons_cta">
          {{ $t('sign_up_callout.buttons.cta') }}
        </Anchor>
        <Button appearance="Link" @click="disappearForThisSession">
          {{ $t('sign_up_callout.buttons.close') }}
        </Button>
      </div>
    </Accordion>
  </section>
</template>

<style lang="postcss">
.sticky-sign-up-panel {
  bottom: 0;
  background-color: var(--surface-light-40);
  box-shadow: 0px -4px 16px 0px rgba(0, 0, 0, 0.25);
  padding: var(--space-50) var(--space-50) 0 var(--space-50);
  position: fixed;
  width: 100%;
  z-index: 1;

  @media (min-width: 640px) {
    display: none;
  }

  .sticky-sign-up-panel__title {
    text-transform: none;
  }
  .sticky-sign-up-panel__buttons {
    display: flex;
    gap: var(--space-60);
    margin-top: var(--space-70);
    .sticky-sign-up-panel__buttons_cta {
      width: 100%;
    }
  }
  .accordion {
    details {
      border: none;
    }
  }
}
</style>
